export class RequestsEvolutionSummaryApi
{
    dateUtc: string;
    urgencyId: number;
    countCreated: number;
    countClosed: number;
}
